import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../../../core/base/base.service';
import { GenericMetrikStatusModel } from '../../../../core/models/generic-metrik-status.model';
import { AuthService } from '../../../../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class GenericMetrikStatusService extends BaseService<GenericMetrikStatusModel> {
  defaultSort = 'createdAt';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'generic-metrik-status', authService);
  }
}
